/**
 * The way into the builder: a round button, top right, showing the face it
 * will change, with a pencil on it. Placed on the child's page and on the
 * full valley, so "change how I look" is always one tap from where a child
 * sees themself.
 */

import { outfitIcon, type AvatarSpec } from './avatar';
import { Character } from './Character';
import './builder.css';

export function BuilderLaunch({
  spec,
  label,
  onOpen,
}: {
  /** The face to show. `undefined` (a screen with no one owner) shows clothes. */
  spec: AvatarSpec | null | undefined;
  /** Read out and shown on hover, e.g. "Change my character". */
  label: string;
  onOpen: () => void;
}) {
  return (
    <button type="button" className="builder-launch" aria-label={label} title={label} onClick={onOpen}>
      {spec === undefined ? (
        <span
          className="builder-launch-face builder-launch-clothes"
          // eslint-disable-next-line react/no-danger -- a fixed glyph, no text
          dangerouslySetInnerHTML={{ __html: outfitIcon(0, '#e0a458', 30) }}
        />
      ) : (
        <span className="builder-launch-face">
          <Character spec={spec} size={46} />
        </span>
      )}
      <span className="builder-launch-mark" aria-hidden="true">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 13l1-3.5 6.8-6.8a1.6 1.6 0 0 1 2.3 2.3L6.3 11.8 3 13z" />
        </svg>
      </span>
    </button>
  );
}
